<template>
  <v-container class="tourist-scan-page" fluid v-if="hasAccessToPage">
    <v-row justify="start" class="mx-4">
      <v-row justify="start" class="mx-4">
        <v-col cols="12" sm="12" md="12" lg="12" xl="11">
          <CasesCreatedTable :storedVistorSubjects="storedVistorSubjects">
            <template v-slot:headerTableRight>
              <!-- create new visitor modal -->
              <CreateCaseModal @caseCreated="setSubjectsCreatedLocalStorage" />
            </template>
          </CasesCreatedTable>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
  <NoAccessMessage v-else />
</template>

<script>
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import NoAccessMessage from '@/components/generic/no-access-message.vue';
import CreateCaseModal from '@/views/CreateCasePage/components/CreateCaseModal/CreateCaseModal.vue';
import CasesCreatedTable from '@/views/CreateCasePage/components/CasesCreatedTable.vue';

export default {
  mixins: [SharedFunctions],
  components: {
    NoAccessMessage,
    CreateCaseModal,
    CasesCreatedTable
  },
  data() {
    return {
      hasAccessToPage: false,
      storedVistorSubjects: []
    };
  },
  created() {
    this.hasAccessToPage = this.hasAccessToPageMixin();
    if (this.casesInLocalStorage()) {
      this.setSubjectsCreatedLocalStorage();
    }
  },
  methods: {
    setSubjectsCreatedLocalStorage() {
      this.storedVistorSubjects = this.casesInLocalStorage();
    },
    casesInLocalStorage() {
      const casesLocalStorage = localStorage.getItem(`${this.$store.getters.appSlug}_casesCreated`);
      if (casesLocalStorage) return JSON.parse(casesLocalStorage);
      else return false;
    }
  }
};
</script>
